import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=fa382e4a&scoped=true&"
import script from "./UserRow.vue?vue&type=script&lang=ts&"
export * from "./UserRow.vue?vue&type=script&lang=ts&"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=fa382e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa382e4a",
  null
  
)

export default component.exports